src/components/Signup.vue
<template>
  <div class="signup">
    <h2>アカウント作成</h2>
    <input type="email" placeholder="メールアドレス" v-model="usermail" />
    <input type="password" placeholder="パスワード" v-model="password" />
    <input
      type="password"
      placeholder="パスワードの確認"
      v-model="re_password"
      v-bind:class="{'alert-color': out_password }"
      @keydown.enter="signUp"
    />
    <button @click="signUp">登録</button>
    <p>
      アカウントをお持ちですか?
      <router-link to="/signin">ここからサインインしてください</router-link>
    </p>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "Signup",
  data() {
    return {
      usermail: "",
      password: "",
      re_password: "",
      out_password: false
    };
  },
  methods: {
    signUp: function() {
      if (this.password != this.re_password) {
        alert("パスワードが一致しません");
        this.out_password = true;
        this.re_password = "";
        return;
      }
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.usermail, this.password)
        .then(user => {
          firebase.auth().currentUser.sendEmailVerification();
          alert(
            "メールを送信しました。メールのurlを押すことで登録が完了となります。",
            user.email
          );
          this.$router.push("/signin");
        })
        .catch(error => {
          alert(
            "問題が発生しました。時間をおいてもう一度お願いします",
            error.message
          );
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
a {
  color: #42b983;
}
.signup {
  margin-top: 20px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}
input {
  margin: 10px;
  padding: 10px;
}
.alert-color {
  background-color: rgba(255, 0, 0, 0.5);
}
</style>